import AppointmentPreview from './AvailabilityPreview';

import './index.css';

export default AppointmentPreview;
